<script>
	import CreateTaskForm from "./CreateTaskForm.svelte";

	export let recordId;
</script>

<CreateTaskForm isEdit={recordId} />
